import { List, ListItem, Popover } from '@mui/material';
import { Link } from 'app/components/Link';
import moment from 'moment';

export function PopoverFileList({
  open,
  anchorEl,
  onClose,
  fileList,
}: {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  fileList: { name: string; url: string; lastModified: Date }[];
}) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <List>
        {fileList.map((file, i) => (
          <ListItem key={file.name}>
            <a href={file.url} target="_blank">
              {moment(file.lastModified)
                .format('YYYY-MM-DD HH:mm')}{' '}
              {file.name}
            </a>
            { i === 0 ? 
              (
                <strong>&nbsp;(Latest)</strong>
              ) : ''}
          </ListItem>
        ))}
      </List>
    </Popover>
  );
}
